__turbopack_context__.v({
  "answerContent": "LpFaq-module__ZNTv7a__answerContent",
  "answerWrapper": "LpFaq-module__ZNTv7a__answerWrapper",
  "container": "LpFaq-module__ZNTv7a__container",
  "faqList": "LpFaq-module__ZNTv7a__faqList",
  "icon": "LpFaq-module__ZNTv7a__icon",
  "item": "LpFaq-module__ZNTv7a__item",
  "open": "LpFaq-module__ZNTv7a__open",
  "questionButton": "LpFaq-module__ZNTv7a__questionButton",
  "questionText": "LpFaq-module__ZNTv7a__questionText",
  "section": "LpFaq-module__ZNTv7a__section",
});
